// Runtime polyfills for browsers below our effective baseline.
// Imported first in index.tsx so these exist before any dependency uses them.

// `Promise.withResolvers` shipped in Safari 17.4 (Mar 2024). pdfjs-dist@5 (via
// react-pdf) calls it when constructing every PDFDocumentLoadingTask, so on
// older Safari (e.g. 16.6) opening any PDF throws "undefined is not a function".
if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
